export default __webpack_public_path__ + "static/media/Resume(BIKASH SHRESTHA).92ba9da0.pdf";